import { useNavigate, useRoutes } from "react-router-dom";
import { useEffect, Suspense } from "react";
import { getRoutes } from "./config";

export function AppRoutes() {
    const routes = getRoutes();
    const element = useRoutes(routes);

    if (!window.REACT_APP_NAVIGATE) {
        const navigate = useNavigate();
        useEffect(() => {
            window.REACT_APP_NAVIGATE = navigate;
        }, [navigate]);
    }

    return (
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center text-gray-500 font-medium">Loading...</div>}>
            {element}
        </Suspense>
    );
}
